module fdm {

    export interface IAppLayoutControllerScope extends ng.IScope {
        reloadClientInfo: () => void;
    }
    export class AppLayoutController {
        public constructor(
            private $scope: IAppLayoutControllerScope,
            private $rootScope: IAppRootScopeService,
            //private $translate,
            private $localStorage,
            private $window: ng.IWindowService,
            private $q: ng.IQService,
            private msalAuthenticationService,
            private toaster: toaster.IToasterService,
            private clientInfoService: dg.clients.ClientInfoService,
            private applicationInfoService: dg.clients.ApplicationInfoService,
            private usersService: dg.modules.users.UsersService,
            private commandExecutedChannelService: dg.actions.CommandExecutedChannelService,
            private $state: ng.ui.IStateService) { 

                $scope.reloadClientInfo = () => {
                    this.reloadClientInfo();
                };
        }

        currentUser: dg.modules.users.IUser;

        // config
        app: fdm.IApplicationSettings;

        links: dg.restfulApi.Link[];

        $onInit() {
            this.initCustomCss();
            this.initApp();
            this.initTranslation();
            this.initUsers();
            this.initErrors();
        }

        logout = () => {
            this.msalAuthenticationService.logout();
        }

        private initCustomCss() {
            // add 'ie' classes to html
            let isIE = !!navigator.userAgent.match(/MSIE/i);
            if (isIE) {
                angular.element(this.$window.document.body).addClass('ie');
            }

            if (this.isSmartDevice(this.$window)) {
                angular.element(this.$window.document.body).addClass('smart');
            }

        }
        private initApp() {
            this.app = {
                name: '',
                clientName: '',
                clientStatus: 'Enabled',
                logo: '',
                smallLogo: '',
                version: '1.0',
                systemEnv: '',
                // for chart colors
                color: {
                    primary: '#7266ba',
                    info: '#23b7e5',
                    success: '#27c24c',
                    warning: '#fad733',
                    danger: '#f05050',
                    light: '#e8eff0',
                    dark: '#3a3f51',
                    black: '#1c2b36'
                },
                settings: {
                    themeID: 1,
                    navbarHeaderColor: 'bg-black',
                    navbarCollapseColor: 'bg-white-only',
                    asideColor: 'bg-black',
                    headerFixed: true,
                    asideFixed: true,
                    asideFolded: (this.$window.innerWidth > 768 ? false : true),
                    asideDock: false,
                    container: false,
                    footerColor: ''
                }
            };
            // save settings to local storage
            //if (angular.isDefined(this.$localStorage.settings)) {
            //    this.app.settings = this.$localStorage.settings;
            //} else {
            //    this.$localStorage.settings = this.app.settings;
            //}

            //this.$scope.$watch('$ctrl.app.settings', (curVal) => {
            //    if (this.app.settings.asideDock && this.app.settings.asideFixed) {
            //        // aside dock and fixed must set the header fixed.
            //        this.app.settings.headerFixed = true;
            //    }
            //    // save to local storage
            //    this.$localStorage.settings = this.app.settings;
            //}, true);
        }

        private initTranslation() {
              // angular translate
            //$scope.lang = { isopen: false };
            //$scope.langs = { en: 'English' };
            //$scope.selectLang = $scope.langs[$translate.proposedLanguage()] || "English";
            //$scope.setLang = (langKey, $event) => {
            //    // set the current lang
            //    $scope.selectLang = $scope.langs[langKey];
            //    // You can change the language during runtime
            //    $translate.use(langKey);
            //    $scope.lang.isopen = !$scope.lang.isopen;
            //};
        }

        private reloadClientInfo() {
            this.clientInfoService.reloadClientInfo().then((clientInfo) => {
                this.app.name = clientInfo.clientSystemName;
                this.app.clientName = clientInfo.clientName;
                this.app.logo = clientInfo.clientLogoFilePath;
                this.app.smallLogo = clientInfo.clientSmallLogoFilePath;
                this.app.systemEnv = clientInfo.systemEnv;
                this.$rootScope.currentClient = clientInfo;
                this.app.clientStatus = clientInfo.clientStatus;
            });
        }

        private initUsers() {
            this.$rootScope.$watch('userInfo.isAuthenticated', (isAuthenticated: boolean) => {
                //$scope.currentUser = {
                //    aggregateId: null,
                //    userName: '',
                //    displayName: '',
                //    pendingSystemNotificationCount: 0,
                //    pendingUserTasksCount: 0
                //};
                if (isAuthenticated) {
                    this.clientInfoService.getClientInfo().then((clientInfo) => {
                        this.app.name = clientInfo.clientSystemName;
                        this.app.clientName = clientInfo.clientName;
                        this.app.logo = clientInfo.clientLogoFilePath;
                        this.app.smallLogo = clientInfo.clientSmallLogoFilePath;
                        this.app.systemEnv = clientInfo.systemEnv;
                        this.$rootScope.currentClient = clientInfo;
                        this.app.clientStatus = clientInfo.clientStatus;
        
                        if (clientInfo.systemEnv !== 'prod') {
                            this.app.settings.footerColor = 'bg-warning lter text-dark';
                        }
        
                        this.setUserData();
                    }, angular.noop);
                }
            });

            this.commandExecutedChannelService.onCommandExecuted(this.$scope, (c: dg.domain.commands.AggregateCommandBase) => {
                if (c.modelType && c.modelType.toLowerCase() == "user") {
                    this.reload();
                }
            });
        }

        private initErrors() {
            this.$scope.$on('DgEvents.HTTPError', (event, errorData: ng.IHttpPromiseCallbackArg<dg.restfulApi.ErrorResult>) => {
                event.preventDefault();
                var payload: any = errorData.data;
                if (payload && payload.handeled) {
                    return;
                }

                // Errors for responseType: 'blob' arrive as Blob; toast cannot read JSON (export modal parses).
                if (payload instanceof Blob) {
                    return;
                }

                let title = "Error";
                let body = "An error has occurred";
                if (payload) {
                    if (payload.errorType) {
                        title = payload.errorType;
                    }
                    var nestedDetail = payload.data && typeof payload.data === 'object'
                        ? payload.data.detailedMessage
                        : null;
                    if (typeof nestedDetail === 'string' && nestedDetail.trim()) {
                        body = nestedDetail.split('\n')[0].trim();
                    } else if (payload.message && typeof payload.message === 'string') {
                        var msg = payload.message.trim();
                        if (!this.isGenericHttpErrorSummary(msg)) {
                            body = msg;
                        }
                    }
                } else if (errorData.statusText) {
                    body = errorData.statusText;
                } else if (errorData.status <= 0) {
                    title = "No Internet Connection";
                    body = "Please refresh when interent connectivity is restored";
                }

                this.toaster.pop('error', title, body);

            });
        }

        private isGenericHttpErrorSummary(m: string): boolean {
            var t = m.toLowerCase().replace(/\s+/g, ' ').trim();
            return t === 'an error has occurred' || t === 'an error has occured';
        }

        private setUserData() {
            this.usersService.reloadCurrentUser().then(userInfo => {
                this.currentUser = userInfo;
                this.links = this.currentUser.dgMeta.links;
            }, angular.noop);
        }

        private reload() {
            this.setUserData();
        }

        private isSmartDevice($window) {
            // Adapted from http://www.detectmobilebrowsers.com
            var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
            // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
            return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
        }

    }

    angular.module('fdm')
        .component('appLayout', {
            bindings: {
                app: '<'
            },
            controller: AppLayoutController,
            templateUrl: '/app/src/layout/app-layout.html'
        });
}